import React from 'react';
import { Link } from 'react-router-dom'

// Chevron at the header of the page. It appears on all pages except the main landing page.
// Sets the page state to home on click.
// Also contains an overlay div that sits on top of the FCL logo and takes user to the home page.
export default function BackToHome(props) {
    return (<>
                <Link className="backToHome" 
                    onClick={()=>props.setPage('home')}
                    to={`/`}
                >
                    <i className="fa fa-2x fa-chevron-left"></i>
                </Link>
                <Link className="backToHomeLogo" 
                    onClick={()=>props.setPage('home')}
                    to={`/`}
                >
                </Link>
            </>
    )
}